import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Header, Body } from "../styled";
import { Typography } from "@mui/material";
import { format, formatISO } from "date-fns";
import Stack from "@mui/material/Stack";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";

const MilitaryRegistration: FC = () => {
  return (
    <Box mt={1}>
        <Box>
            <TextField
            label="Группа учета"
            variant="outlined"
            size="small"
            sx={{ width: "300px", mb: 1 }}
            />
        </Box>
        <TextField
          label="Категория воинского учета(категория запаса)"
          variant="outlined"
          size="small"
          sx={{ width: "300px", mb: 1 }}
        />
        <Box display="flex" sx={{mb: 1}}>
          <TextField
            label="Состав профиль"
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "300px" }}
          />
          <TextField
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "800px" }}
          />
        </Box>
        <TextField
          label="Категория годности к военной службе"
          variant="outlined"
          size="small"
          sx={{ width: "800px", mb: 1 }}
        />
        <Box display="flex" sx={{mb: 1}}>
          <TextField
            label="Воинское звание"
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "300px" }}
          />
          <TextField
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "800px" }}
          />
        </Box>
        <TextField
          label="Военно-учетная специальность(ВУС)"
          variant="outlined"
          size="small"
          sx={{ width: "800px", mb: 1 }}
        />
        <Box display="flex" alignItems="center" sx={{mb: 1}}>
            <Typography mr={1}>Имеет мобилизационное предписание: </Typography>
            <FormControlLabel
                value="female"
                control={<Radio />}
                label="Да"
            />
            <FormControlLabel
                value="female"
                control={<Radio />}
                label="Нет"
            />
                <TextField
                variant="outlined"
                size="small"
                sx={{ mr: 1, width: "500px" }}
            />
        </Box>
        <Box display="flex" sx={{mb: 1}}>
          <TextField
            label="Военкомат"
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "300px" }}
          />
          <TextField
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "800px" }}
          />
        </Box>
        <Box display="flex" alignItems="center" sx={{mb: 1}}>
            <Typography mr={1}>Забронирован(состоит на спец. учете): </Typography>
            <FormControlLabel
                value="female"
                control={<Radio />}
                label="Да"
            />
            <FormControlLabel
                value="female"
                control={<Radio />}
                label="Нет"
            />
                <TextField
                variant="outlined"
                size="small"
                sx={{ mr: 1, width: "500px" }}
            />
        </Box>
        <TextField
          label="Номер удостоверения"
          variant="outlined"
          size="small"
          sx={{ width: "800px", mb: 1 }}
        />
        <Box>
            <TextField
            label="Код ВЭД"
            variant="outlined"
            size="small"
            sx={{ width: "500px", mb: 1 }}
            />
        </Box>
        <TextField
          label="Код должности"
          variant="outlined"
          size="small"
          sx={{ width: "600px", mb: 1 }}
        />
        <Box>
            <TextField
            label="Дата бронирования"
            variant="outlined"
            size="small"
            sx={{ width: "500px", mb: 1 }}
            />
        </Box>
        <Box display="flex" sx={{mb: 1}}>
          <TextField
            label="Документ воинского учета"
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "300px" }}
          />
          <TextField
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "800px" }}
          />
        </Box>
        <TextField
          label="Номер документа"
          variant="outlined"
          size="small"
          sx={{ width: "600px", mb: 1 }}
        />
        <Box display="flex" sx={{mb: 1}}>
          <TextField
            label="Кем выдан документ"
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "300px" }}
          />
          <TextField
            variant="outlined"
            size="small"
            sx={{ mr: 1, width: "800px" }}
          />
        </Box>
        <TextField
          label="Дата выдачи документа"
          value={format(1683886255004, "dd.MM.yyyy")}
          variant="outlined"
          size="small"
          sx={{ width: "200px", mb: 1 }}
        />
        <Box>
            <TextField
            label="Дата сверки"
            value={format(1683886255004, "dd.MM.yyyy")}
            variant="outlined"
            size="small"
            sx={{ width: "300px", mb: 1 }}
            />
            <TextField
            label="Дата снятия с воинского учета"
            value={format(1683886255004, "dd.MM.yyyy")}
            variant="outlined"
            size="small"
            sx={{ width: "200px", mb: 1, ml: 35 }}
            />
        </Box>
        <Box display="flex" alignItems="center">
            <TextField
            label="ФИО"
            variant="outlined"
            size="small"
            sx={{ width: "500px", mb: 1 }}
            />
            <TextField
            label="Причина снятия"
            variant="outlined"
            size="small"
            sx={{ width: "200px", ml: 10 }}
            />
            <Typography ml={1}>(1-по возарсту,2-по состоянию здоровья,3-смерть)</Typography>
        </Box>
    </Box>
  );
};

export default MilitaryRegistration;
